import { render, staticRenderFns } from "./TerminalLearningObjectEnd.vue?vue&type=template&id=b233e96c&"
import script from "./TerminalLearningObjectEnd.vue?vue&type=script&lang=js&"
export * from "./TerminalLearningObjectEnd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports